/**
 * 参考:
 * https://suanmei.github.io/2018/08/23/h5_call_app/
 * https://zhuanlan.zhihu.com/p/431136463
 */
import { CallappConfig, CallappOptions, Intent } from '@/lib/callapp-lib/types'
import CallApp from '@/lib/callapp-lib'
import { OpenUrlEnum } from '@/types/url-enum'
import { isAndroid } from '@/utils/is'

export interface ICallappOptions<Params = Record<string, unknown>> {
  param?: Params
  scheme?: Partial<{
    protocol: string
    host: string
    port: string | number
  }>
  outChain?: Partial<{
    protocol: string
    path: string
    key: string
  }>
  intent?: Partial<Intent>
  universal?: Partial<{
    host: string
    path: string
    pathKey: string
  }>
  appstore?: string
  yingyongbao?: string
  fallback?: string // 唤端失败后跳转的地址
  timeout?: number
  logFunc?: (status: 'pending' | 'failure' | 'success') => void
  buildScheme?: (config: CallappConfig, options: CallappOptions) => string
  path?: string
  callback?: () => void
  universalPath?: string
}

/** H5调起APP */
export function useCallApp(options: ICallappOptions, statusFunc: (status: 'pending' | 'failure' | 'success') => void) {
  const appPackage = isAndroid ? (process.env.VUE_APP_ANDROID_PACKAGE_ID || '') : 'com.echolink3d.sea'
  const appstore = OpenUrlEnum.IOS_APP_STORE
  const fallback = OpenUrlEnum.GOOGLE_PLAY

  const appScheme = isAndroid ? 'weelife' : 'echolink3d'

  if (options.universal?.host) {
    options.param = {
      ...options.param,
      ulOriginalUrl: options.param?.ulOriginalUrl || '',
      ulRedirectUrl: options.param?.ulRedirectUrl || OpenUrlEnum.IOS_APP_STORE
    }
  }

  const callLib = new CallApp({
    scheme: {
      protocol: options.scheme?.protocol || appScheme
    },
    intent: {
      package: options.intent?.package || appPackage,
      scheme: options.intent?.scheme || appScheme
    },
    universal: options.universal || undefined,
    appstore: options.appstore || appstore,
    yingyongbao: options.yingyongbao || '',
    fallback: options.fallback || fallback,
    timeout: options.timeout || 3000,
    logFunc: (status) => {
      statusFunc(status)
    }
  })
  callLib.open({
    path: options.path || 'invite.room',
    param: options.param,
    callback: () => { // 自定义唤端失败回调函数。传递 callback 会覆盖 callapp-lib 库中默认的唤端失败处理逻辑。
    }
  })
}
